/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import RepInfo from "@eisinc/App/Components/RepInfo/RepInfo";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getQuoteState } from "@insite/client-framework/Store/Data/Quotes/QuotesSelector";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { RfqQuoteDetailsPageContext } from "@insite/content-library/Pages/RfqQuoteDetailsPage";
import { GridContainer, GridItem } from "@insite/mobius/index";
import React from "react";
import { connect, ResolveThunks } from "react-redux";

const mapStateToProps = (state: ApplicationState) => ({
    quoteState: getQuoteState(state, state.pages.rfqQuoteDetails.quoteId),
});

const mapDispatchToProps = {};

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const RfqQuoteDetailsRepInfo = ({ quoteState }: Props) => {
    const quote = quoteState.value;
    const primarySalesPersonData = (quote && quote.properties && quote.properties.primarySalesRep) || "";
    const secondarySalesPersonData = (quote && quote.properties && quote.properties.secondarySalesRep) || "";
    const billTo = quote && quote.billTo;

    if (!quote || (!primarySalesPersonData && !secondarySalesPersonData)) {
        return null;
    }

    return (
        <GridContainer>
            <GridItem width={[12, 6, 6, 6, 6]}>
                <RepInfo
                    salesPersonData={secondarySalesPersonData}
                    clickable={true}
                    title={translate("Inside Sales Reps")}
                    billTo={billTo}
                />
            </GridItem>
            <GridItem width={[12, 6, 6, 6, 6]}>
                <RepInfo
                    salesPersonData={primarySalesPersonData}
                    clickable={true}
                    chat={true}
                    title={translate("Outside Sales Reps")}
                    billTo={billTo}
                />
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(RfqQuoteDetailsRepInfo),
    definition: {
        displayName: "Quote Details Rep Info",
        allowedContexts: [RfqQuoteDetailsPageContext],
        fieldDefinitions: [],
        group: "RFQ Quote Details",
    },
};

export default widgetModule;
